import { apiGetBlob, apiPostBlob } from './client';

// Stateless inline PDF — used by US1 (download from the Estimate screen
// without saving the valuation).
export function generatePdf({ name, inputs }) {
  return apiPostBlob('/api/v1/pdf', { name, inputs });
}

// PDF for a saved valuation — used by US2 (download from a Dashboard row).
export function getValuationPdf(publicId) {
  return apiGetBlob(`/api/v1/valuations/${encodeURIComponent(publicId)}/pdf`);
}
